import { Routes, Route, Navigate } from "react-router-dom";
import PublicLayout from "./pages/public/PublicLayout";
import Home from "./pages/public/Home";
import Programs from "./pages/public/Programs";
import ProgramDetail from "./pages/public/ProgramDetail";
import Contact from "./pages/public/Contact";
import Reservation from "./pages/public/Reservation";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminLayout from "./pages/admin/AdminLayout";
import Settings from "./pages/admin/Settings";
import CompanyTab from "./pages/admin/Settings/CompanyTab";
import TravelPricingTab from "./pages/admin/Settings/TravelPricingTab";
import EmailAccountsTab from "./pages/admin/Settings/EmailAccountsTab";
import ProgramsList from "./pages/admin/Programs/ProgramsList";
import ProgramForm from "./pages/admin/Programs/ProgramForm";
import Calendar from "./pages/admin/Calendar/Calendar";
import ReservationsList from "./pages/admin/Reservations/ReservationsList";
import ReservationDetail from "./pages/admin/Reservations/ReservationDetail";
import InvoicesList from "./pages/admin/Invoices/InvoicesList";
import KindergartensList from "./pages/admin/Kindergartens/KindergartensList";
import KindergartenForm from "./pages/admin/Kindergartens/KindergartenForm";
import SiteImagesAdmin from "./pages/admin/SiteImages/SiteImages";
import RequireAuth from "./components/RequireAuth";

export default function App() {
  return (
    <Routes>
      {/* Veřejné */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/programy" element={<Programs />} />
        <Route path="/programy/:id" element={<ProgramDetail />} />
        <Route path="/kontakt" element={<Contact />} />
      </Route>
      {/* Rezervace má vlastní layout bez header/footer — hodně focused */}
      <Route path="/rezervace" element={<Reservation />} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="settings" element={<Settings />}>
          <Route index element={<Navigate to="company" replace />} />
          <Route path="company" element={<CompanyTab />} />
          <Route path="travel" element={<TravelPricingTab />} />
          <Route path="emails" element={<EmailAccountsTab />} />
        </Route>
        <Route path="programs" element={<ProgramsList />} />
        <Route path="programs/new" element={<ProgramForm />} />
        <Route path="programs/:id" element={<ProgramForm />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="reservations" element={<ReservationsList />} />
        <Route path="reservations/:id" element={<ReservationDetail />} />
        <Route path="invoices" element={<InvoicesList />} />
        <Route path="kindergartens" element={<KindergartensList />} />
        <Route path="kindergartens/new" element={<KindergartenForm />} />
        <Route path="kindergartens/:id" element={<KindergartenForm />} />
        <Route path="site-images" element={<SiteImagesAdmin />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
